export var GAME_NAMES = {
    texasholdem: "Holdem NL",
    turkishpoker: "Turkish Poker",
    omaha4: "Omaha 4",
    omaha5: "Omaha 5",
};
